/* eslint-disable */
var util = {
  methods: {
    instantiateSimulationHelper() {
      var unix = parseInt((new Date()).getTime() / 1000)

      var s = {
        code: '',
        label: '',
        created: unix,
        changed: unix,
        active: 1,
        dadosIniciais: '',
        rebanhoReproducao: '',
        rebanhoRecria: '',
        bovinoAbate: '',
        bovinoOutro: '',
        proLabore: '',
        outrasReceitas: '',
        dadosDasDespesas: '',
        dadosManutencao: '',
        dadosDespesasAnimal: '',
        dadosDespesasServicos: '',
        dadosRecursosPastagensOutros: '',
        dadosRecursosInstalacoes: '',
        dadosRecursosMaquinas: '',
        dadosRecursosAnimais: ''

      }

      return s
    },
    validateHelper(simulation) {
      return true
    }
  }
}

export default util
